import React from 'react';

import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
import CategoryContainer from '../containers/categorycontainer/CategoryContainer';

import AvatarList from '../components/avatar-list/avatar-list';

import headerImage from '../media/logosmall.png';

import avatarOlivia from '../media/avatars/oliviableeckx.png';
import avatarIrakli from '../media/avatars/irakli-dautashvili.jpg';
import avatarAshish from '../media/avatars/ashish-vaidya.jpg';
import avatarDanut from '../media/avatars/danut-codrescu.png';
import avatarHan from '../media/avatars/han-tambuyzer.jpg';
import avatarIdes from '../media/avatars/ides-bauwens.jpg';
import avatarNicolas from '../media/avatars/nicolas-dosselaere.jpg';

import 'bootstrap/dist/css/bootstrap.css';
import './team.styl';

import { PageText, avatarItemList, Categories } from '../input-text/en/team_page';

class OurStory extends React.Component {
  constructor(props) {
    super(props);
    avatarItemList[0].avatar = avatarOlivia;
    avatarItemList[1].avatar = avatarIrakli;
    avatarItemList[2].avatar = avatarAshish;
    avatarItemList[3].avatar = avatarDanut;
    avatarItemList[4].avatar = avatarHan;
    avatarItemList[5].avatar = avatarIdes;
    avatarItemList[6].avatar = avatarNicolas;
  }

  render(){
    return (
      <div>
        <SimpleContainer color='dark' containerClass='header-container padded-container'>
          <div className='col-sm-4 hidden-xs header-image-container'>
            <img src={headerImage} alt="aircheckr logo" />
          </div>
          <div className='col-xs-12 col-sm-8 header-info'>
            <h1>{PageText._1}</h1>
            <p>{PageText._2}</p>
          </div>
        </SimpleContainer>
        <div className="team container">
          <div className="row">
            <div className="col-sm-3">
              <h2 className="team__title">Core team</h2>
            </div>
            <div className="col-sm-9">
              <div className="team__avatars">
                <AvatarList items={ avatarItemList } />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3">
              <h2 className="team__title">{ Categories._1.title }</h2>
            </div>
            <div className="col-sm-9">
              <p>
                { Categories._1.subcategories[0].text }
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default OurStory;



// WEBPACK FOOTER //
// ./src/routes/Team.js